// Display helpers for the firewall top reports page. The report presets
// (which field is the item, which are metrics and their units) come from the
// backend catalog; this file only turns values into text.

const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']

export function formatBytes (value) {
  if (typeof value !== 'number' || !isFinite(value)) return '—'
  let size = value
  let unit = 0
  while (size >= 1024 && unit < BYTE_UNITS.length - 1) {
    size /= 1024
    unit += 1
  }
  const digits = size >= 100 || unit === 0 ? 0 : 1
  return `${size.toFixed(digits)} ${BYTE_UNITS[unit]}`
}

export function formatCount (value) {
  if (typeof value !== 'number' || !isFinite(value)) return '—'
  return value.toLocaleString('en-US')
}

// Short form for chart axes and data labels: 1.2M, 35k.
export function formatCompact (value) {
  if (typeof value !== 'number' || !isFinite(value)) return ''
  const abs = Math.abs(value)
  if (abs >= 1e9) return `${(value / 1e9).toFixed(1)}B`
  if (abs >= 1e6) return `${(value / 1e6).toFixed(1)}M`
  if (abs >= 1e3) return `${(value / 1e3).toFixed(abs >= 1e4 ? 0 : 1)}k`
  return String(Math.round(value))
}

export function formatMetric (value, unit) {
  return unit === 'bytes' ? formatBytes(value) : formatCount(value)
}

export function formatMetricCompact (value, unit) {
  return unit === 'bytes' ? formatBytes(value) : formatCompact(value)
}

// PAN-OS App-ID "risk" goes from 1 (lowest) to 5 (highest).
// TODO(user): these thresholds decide which applications look alarming on the
// page. The default below follows the PAN-OS scale literally; tune it to what
// the SOC treats as worth a second look for Corona.
export function riskVariant (risk) {
  if (typeof risk !== 'number') return 'light'
  if (risk >= 4) return 'danger'
  if (risk === 3) return 'warning'
  return 'success'
}

export function formatDate (value) {
  if (!value) return '—'
  return new Date(value).toLocaleString('en-CO', {
    timeZone: 'America/Bogota',
    hour12: false
  })
}

export function formatAge (seconds) {
  if (typeof seconds !== 'number') return 'unknown'
  if (seconds < 90) return `${seconds} s ago`
  if (seconds < 3600) return `${Math.round(seconds / 60)} min ago`
  if (seconds < 172800) return `${(seconds / 3600).toFixed(1)} h ago`
  return `${Math.round(seconds / 86400)} d ago`
}

export function windowLabel (hours) {
  if (hours === 1) return 'Last hour'
  if (hours < 48) return `Last ${hours} hours`
  return `Last ${Math.round(hours / 24)} days`
}
